import { render, staticRenderFns } from "./MarksListPager.vue?vue&type=template&id=7e7ca32b"
import script from "./MarksListPager.vue?vue&type=script&lang=js"
export * from "./MarksListPager.vue?vue&type=script&lang=js"
import style0 from "./MarksListPager.vue?vue&type=style&index=0&id=7e7ca32b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports